import { Box, Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import handIcon from "@/assets/imgs/layout/open-hand.png";
import sirenIcon from "@/assets/imgs/layout/siren.png";

import { useAppDispatch, useAppSelector } from "@/app/hooks";

import { ACTIVITY_LIMIT_DURATION } from "@/constants/const";
import useStyles from "./index.styles";
import { setRateLimitExceeded } from "@/features/auth";

interface RateLimitPopupProps {
  openRateLimitPopup: boolean;
}

const RateLimitPopup: React.FC<RateLimitPopupProps> = ({
  openRateLimitPopup,
}) => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();

  const { activityTimestamps } = useAppSelector((state) => state.auth);

  const [remainTime, setRemainTime] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const remainTime =
        ACTIVITY_LIMIT_DURATION -
        (Math.floor(new Date().getTime() / 1000) -
          (activityTimestamps.at(0) || 0));
      if (remainTime >= 0) {
        setRemainTime(remainTime);
      } else {
        clearInterval(intervalId);
        dispatch(setRateLimitExceeded(false));
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [activityTimestamps, dispatch]);

  return (
    <Dialog open={openRateLimitPopup} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.contentBody}>
          <Box
            component="img"
            src={sirenIcon}
            className={classes.sirenIcon}
          ></Box>

          <Box className={classes.title}>Hold up, mobster!</Box>

          <Box className={classes.description}>
            You reached the activity limit. Slow down before trying again.
          </Box>

          <Box className={classes.message}>
            <Box component="img" src={handIcon} alt="" /> 10 actions per minute
          </Box>

          <Box className={classes.countdown}>
            Try again in {remainTime} seconds.
          </Box>

          <Box className={classes.description}>
            Need a higher limit? Upgrade to Player+ <Link to={"/premium/"}>here</Link>
            {" "}for unlimited page loads.
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default RateLimitPopup;
